import { map, props, pipe } from "ramda";

export default function collectionToRows<T>(collection: T[], columns: string[]) {
    //map to Table of Rows and replace all undefined values with null
    const rows = map(pipe(props(columns), map((value: any) => value ?? null)))(collection)
    return rows
}